import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { setRiskGapAnswer } from './utils/setRiskGapAnswer';
import { PatientCacheRef, PatientServiceEvents } from './usePatientService';

export const useUpdatePatient = (events: PatientServiceEvents, patientCache: PatientCacheRef) => {
    const services = React.useContext(ServicesContext);

    const updatePatient = useCallback(
        async (id: number, params: Partial<PatientType> | NewNoteType) => {
            const result: ApiDataResponseType<PatientType> = await services.api.call({
                method: 'put',
                url: `/api/patients/${id}`,
                data: params,
            });

            result.data.risk_gaps = result.data.risk_gaps.map(setRiskGapAnswer);
            patientCache.current[id] = result.data;

            services.events.publish(events.patient_updated);

            return result.data;
        },
        [services.api, services.events, events, patientCache]
    );

    return updatePatient;
};
